<section class="market-section">
  <section class="filter-shell" [class.is-open]="filtersOpen">
    <button type="button" class="filter-toggle" (click)="toggleFilters()" [attr.aria-expanded]="filtersOpen">
      <span>
        <i class="pi pi-sliders-h"></i>
        {{ text('Search filters', 'فلاتر البحث') }}
      </span>
      <strong>{{ filtersOpen ? text('Hide', 'إخفاء') : text('Show', 'عرض') }}</strong>
    </button>

    @if (filtersOpen) {
    <form class="market-filter" [formGroup]="form" (ngSubmit)="applyFilters()">
      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicAvailabilityOrigin" formControlName="corridorOrigin" [options]="originOptions"
              optionLabel="label" optionValue="value" appendTo="body" class="w-full" [filter]="true"
              [showClear]="true" (onFilter)="onLocationOptionFilter('origin', $event)"></p-select>
            <label for="publicAvailabilityOrigin">{{ text('Pickup', 'الاستلام') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicAvailabilityDestination" formControlName="corridorDestination"
              [options]="destinationOptions" optionLabel="label" optionValue="value" appendTo="body" class="w-full"
              [filter]="true" [showClear]="true"
              (onFilter)="onLocationOptionFilter('destination', $event)"></p-select>
            <label for="publicAvailabilityDestination">{{ text('Dropoff', 'التسليم') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicAvailabilityEquipment" formControlName="equipmentType" [options]="equipmentOptions"
              optionLabel="label" optionValue="value" appendTo="body" class="w-full" [filter]="true"
              [showClear]="true" (onFilter)="onLocationOptionFilter('equipment', $event)"></p-select>
            <label for="publicAvailabilityEquipment">{{ text('Equipment type', 'نوع المعدة') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-chart-bar"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-inputNumber inputId="publicAvailabilityWeight" formControlName="weightKg" [min]="0"
              [showButtons]="false"></p-inputNumber>
            <label for="publicAvailabilityWeight">{{ text('Weight kg', 'الوزن كجم') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-table"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-inputNumber inputId="publicAvailabilityPallets" formControlName="pallets" [min]="0"
              [showButtons]="false"></p-inputNumber>
            <label for="publicAvailabilityPallets">{{ text('Pallets', 'المنصات') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-actions">
        <button type="submit" class="button primary">
          <i class="pi pi-search"></i>
          <span>{{ text('Search', 'بحث') }}</span>
        </button>
        <button type="button" class="button ghost" (click)="clearFilters()">
          <i class="pi pi-filter-slash"></i>
          <span>{{ text('Clear', 'مسح') }}</span>
        </button>
      </div>
    </form>
    }
  </section>

  <div class="section-heading">
    <div>
      <h2>{{ text('Public availability', 'التوفرات العامة') }}</h2>
      <p>{{ page?.totalElements || 0 }} {{ text('open availabilities', 'توفيرات نشطة') }}</p>
    </div>
    <a class="button ghost ai-agent-button" routerLink="/public/ai-broker">
      <i class="pi pi-microchip-ai"></i>
      <span>{{ text('AI agent', 'وكيل الذكاء') }}</span>
    </a>
    <button type="button" class="button ghost" (click)="login()">
      <i class="pi pi-plus"></i>
      <span>{{ text('Login to post availability', 'تسجيل الدخول لنشر توفر') }}</span>
    </button>
  </div>

  @if (loading) {
    <div class="state-panel">{{ text('Loading public availability...', 'جاري تحميل التوفرات العامة...') }}</div>
  } @else if (error) {
    <div class="state-panel error">{{ error }}</div>
  } @else if (availabilities.length === 0) {
    <div class="state-panel">{{ text('No public availability matches these filters.', 'لا توجد توفـرات عامة مطابقة لهذه الفلاتر.') }}</div>
  } @else {
    <div class="market-grid">
      @for (availability of availabilities; track trackById($index, availability)) {
        <article class="market-card">
          <div class="card-head">
            <div>
              <p class="reference">{{ availability.referenceNumber || text('Public availability', 'توفر عام') }}</p>
              <h3>
                {{ availability.corridorOriginLabel || availability.corridorOrigin || text('Origin flexible', 'مرن من حيث الاستلام') }}
                {{ text('to', 'إلى') }}
                {{ availability.corridorDestinationLabel || availability.corridorDestination || text('Destination flexible', 'مرن من حيث التسليم') }}
              </h3>
            </div>
            <span class="status-pill">{{ availability.status || 'OPEN' }}</span>
          </div>

          @if (signalBadges(availability).length) {
          <div class="signal-row">
            @for (badge of signalBadges(availability); track badge.label) {
              <span class="signal-chip" [class.urgent]="badge.strong">
                <i [class]="badge.icon"></i>{{ badge.label }}
              </span>
            }
          </div>
          }

          @if (availability.availablePallets) {
            <div class="tag-row">
              <span class="info-tag"><i class="pi pi-table"></i>{{ availability.availablePallets }} {{ text('pallets', 'منصات') }}</span>
            </div>
          }

          <div class="meta-grid">
            <div class="meta-item">
              <i class="pi pi-calendar"></i>
              <div>
                <span>{{ text('Posted', 'نُشر') }}</span>
                <strong>{{ formatRelativeTime(availability.createdAt) }}</strong>
              </div>
            </div>
            <div class="meta-item">
              <i class="pi pi-truck"></i>
              <div>
                <span>{{ text('Equipment', 'المعدة') }}</span>
                <strong>{{ availability.equipmentTypeLabel || availability.equipmentType || text('Equipment not listed', 'المعدة غير مذكورة') }}</strong>
              </div>
            </div>
            <div class="meta-item">
              <i class="pi pi-chart-bar"></i>
              <div>
                <span>{{ text('Capacity', 'السعة') }}</span>
                <strong>{{ availability.maxWeightKg ? (availability.maxWeightKg + ' kg') : text('Flexible', 'مرن') }}</strong>
              </div>
            </div>
            <div class="meta-item">
              <i class="pi pi-wallet"></i>
              <div>
                <span>{{ text('Price', 'السعر') }}</span>
                <strong>{{ formatMoney(availability.routePrice, availability.currency) }}</strong>
              </div>
            </div>
          </div>

          <div class="trust-strip" [class.muted]="!isTrustAvailable(availability.trustSummary)">
            <i class="pi pi-shield"></i>
            <div>
              <strong>{{ trustTitle(availability.trustSummary) }}</strong>
            </div>
            @if (trustScoreLabel(availability.trustSummary)) {
              <b>{{ trustScoreLabel(availability.trustSummary) }}</b>
            }
          </div>

          <div class="card-actions">
            <a class="button ghost" [routerLink]="['/public/availabilities', availability.id]" (click)="openAvailability(availability.id)">
              <i class="pi pi-eye"></i>
              <span>{{ text('View details', 'عرض التفاصيل') }}</span>
            </a>
          </div>
        </article>
      }
    </div>

    <div class="pagination-bar">
      <button type="button" class="button ghost" [disabled]="!page || page.number === 0" (click)="previousPage()">
        <i class="pi pi-chevron-left"></i>
        <span>{{ text('Previous', 'السابق') }}</span>
      </button>
      <span>{{ text('Page', 'الصفحة') }} {{ (page?.number || 0) + 1 }} {{ text('of', 'من') }} {{ page?.totalPages || 1 }}</span>
      <button
        type="button"
        class="button ghost"
        [disabled]="!page || page.number + 1 >= page.totalPages"
        (click)="nextPage()"
      >
        <span>{{ text('Next', 'التالي') }}</span>
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>
  }
</section>
